module.exports = "<div class=\"qr-code-viewer\">\n  <div ng-bind-html=\"$ctrl.qrImageTag\"></div>\n</div>\n";